import React from 'react';
import { View, Image, StyleSheet, TouchableOpacity, Text } from 'react-native';
import CS from '../constants/Styles';
import Colors from '../constants/Colors';
import { AntDesign } from '@expo/vector-icons';

export default function PhotoIdText({ ...props }) {
  return (
    <View style={styles.container}>
      <Text style={[CS.smallText, CS.lightBlueText]}>{props.type || 'Under Review'}</Text>
      {props.remove &&
      <TouchableOpacity style={styles.removeContainer} onPress={() => props.remove(props.version)} activeOpacity={0.7} >
        <AntDesign name="closecircleo" size={24} color={Colors.white} style={{ position: 'absolute' }} />
        <AntDesign name="closecircle" size={24} color={Colors.lightBlue2} style={{ position: 'absolute' }} />
      </TouchableOpacity>}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 10,
    borderRadius: 10,
    borderStyle: 'solid',
    borderWidth: 2,
    borderColor: Colors.lightBlue,
    // overflow: 'hidden',
    width: '100%',
    height: 42,
    paddingLeft: 10,
    flexDirection: 'row',
  },
  removeContainer: {
    // position: 'absolute',
    // top:8,
    // right: 8,
    // top: 0,
    // right: 0,
    height: '100%',
    // width: 40,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 10,
    marginRight: 8,
    // backgroundColor: 'red',
    zIndex: 100,
    marginLeft: 'auto',
  },
});

